import { render, staticRenderFns } from "./AppLayoutDefault.vue?vue&type=template&id=64bccb14&scoped=true&"
import script from "./AppLayoutDefault.vue?vue&type=script&lang=js&"
export * from "./AppLayoutDefault.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutDefault.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AppLayoutDefault.vue?vue&type=style&index=1&id=64bccb14&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bccb14",
  null
  
)

export default component.exports